import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { Routes, Route, useNavigate } from "react-router-dom"
import { layoutTypes } from "./constants/layout"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./custom.css"
import "./global.css"
import "./custom-rtl.scss"

// Import responsive scss
import "./responsive.scss"

// import fakeBackend from "./helpers/AuthType/fakeBackend"
import SweatAlert from "components/Shared/SweatAlert"

import "primereact/resources/themes/lara-light-blue/theme.css" // Theme
import "primereact/resources/primereact.min.css" // Core styles
import "primeicons/primeicons.css" // Icons
import { useTranslation } from "react-i18next"

const getLayout = layoutType => {
  let Layout = VerticalLayout
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout
      break
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout
      break
    default:
      break
  }
  return Layout
}

const App = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const handleUnauthorized = () => {
      navigate("/unauthorized", { replace: true }) // Navigate without reloading
    }

    window.addEventListener("unauthorized", handleUnauthorized)

    return () => {
      window.removeEventListener("unauthorized", handleUnauthorized)
    }
  }, [navigate])

  document.title = t("Yamama")

  const selectLayoutState = state => state.Layout
  const LayoutProperties = createSelector(selectLayoutState, layout => ({
    layoutType: layout.layoutType,
  }))

  const { layoutType } = useSelector(LayoutProperties)

  const Layout = getLayout(layoutType)
  const { isVisible, text, type } = useSelector(state => state.Alert)

  // SET CLASS BASED ON CURRENT LANGUAGE
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     const savedLanguage = localStorage.getItem("I18N_LANGUAGE") || "en"

  //     i18n.changeLanguage(savedLanguage)

  //     // Set the initial direction based on saved language
  //     if (savedLanguage === "sa") {
  //       document.body.setAttribute("dir", "rtl")
  //     } else {
  //       document.body.setAttribute("dir", "ltr")
  //     }
  //   }
  // }, [])

  return (
    <React.Fragment>
      {isVisible && <SweatAlert text={text} type={type} />}

      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
